/* eslint-disable camelcase */
const dotenv = require('dotenv');
dotenv.config();

const env = process.env.REACT_APP_ENV || 'staging';

const oauth = {
  endpoint:
    env === 'staging'
      ? 'https://stag.supersoccer.tv/accounts/_/oauth2/v1'
      : 'https://supersoccer.tv/accounts/_/oauth2/v1',
  endpointInternal:
    env === 'staging'
      ? 'http://10.220.0.148/accounts/_/oauth2/v1'
      : 'http://nginx.infra.sstv.local/accounts/_/oauth2/v1',
  appKey: '9KSkjpIb3I',
  appSecret: 'VEwMSSob5hPhXveRgTGXpSYmoTjDFVFq4BT1FXx2aEBJbqNhu3NRyaF83GsqLz9l'
};

const allowedRedirectHostname = [
  'beta.supersoccer.tv',
  'supersoccer.tv',
  'v4.stag.supersoccer.tv',
  'stag.supersoccer.tv',
  'alpha.supersabar.com',
  'kedasi.supersoccer.tv',
  'localhost:3000',
  'localhost'
];

const favicon =
  'https://cdn01.sent.tv/VaJOZGhQx6DvfhUwVYvt_sent_1565602365.png';

const options = {
  development: {
    port: 3000,
    endpoints: {
      // clientUrl: 'https://stag.supersoccer.tv',
      // serverUrl: 'https://stag.supersoccer.tv',
      // api: 'https://stag.supersoccer.tv/api/v2',
      // auth: 'https://stag.supersoccer.tv/accounts',
      // domain: 'https://stag.supersoccer.tv',
      // ads: 'https://api.stag.supersoccer.tv',
      clientUrl: 'https://beta.supersoccer.tv',
      serverUrl: 'https://beta.supersoccer.tv',
      api: 'https://beta.supersoccer.tv/api/v2',
      apiInternal: 'https://beta.supersoccer.tv/api/v2',
      auth: 'https://beta.supersoccer.tv/accounts',
      authInternal: 'https://beta.supersoccer.tv/accounts',
      domain: 'https://beta.supersoccer.tv',
      ads: 'https://api.stag.supersoccer.tv',
      articleDNSInternal: 'http://articles.core.sstv.local/external',
      configDNSInternal: 'http://config.core.sstv.local',
      setting: {
        timeout: 10000,
        maxRedirects: 1
      }
    }
  },
  staging: {
    port: 3000,
    endpoints: {
      clientUrl: 'https://stag.supersoccer.tv',
      serverUrl: 'https://stag.supersoccer.tv',
      api: 'https://stag.supersoccer.tv/api/v2', //'/api/v2',//'https://stag.supersoccer.tv/api/v2',
      apiInternal: 'http://10.220.0.148/api/v2',
      auth: 'https://stag.supersoccer.tv/accounts',
      authInternal: 'http://10.220.0.148/accounts',
      domain: 'https://stag.supersoccer.tv',
      ads: 'https://api.stag.supersoccer.tv',
      articleDNSInternal: 'http://articles.core.sstv.local/external', // http://10.220.0.22/external
      configDNSInternal: 'http://config.core.sstv.local', // http://10.220.0.12
      // clientUrl: 'https://beta.supersoccer.tv',
      // serverUrl: 'https://beta.supersoccer.tv',
      // api: 'https://beta.supersoccer.tv/api/v2',
      // auth: 'https://beta.supersoccer.tv/accounts',
      // domain: 'https://beta.supersoccer.tv',
      // ads: 'https://api.stag.supersoccer.tv',
      setting: {
        timeout: 10000,
        maxRedirects: 1
      }
    }
  },
  production: {
    port: 3000,
    endpoints: {
      clientUrl: 'https://supersoccer.tv',
      serverUrl: 'https://supersoccer.tv',
      api: 'https://supersoccer.tv/api/v2',
      apiInternal: 'http://nginx.infra.sstv.local/api/v2',
      auth: 'https://supersoccer.tv/accounts',
      authInternal: 'http://nginx.infra.sstv.local/accounts',
      domain: 'https://supersoccer.tv',
      ads: 'https://api-beta.supersoccer.tv',
      articleDNSInternal: 'http://articles.core.sstv.local/external',
      configDNSInternal: 'http://config.core.sstv.local',
      setting: {
        timeout: 10000,
        maxRedirects: 1
      }
    }
  }
};

const config = options[env];

// const config = require('@source/global/config')[env];

module.exports = {
  // Node.js app
  env,
  ...config,
  favicon,
  trustProxy: process.env.TRUST_PROXY || 'loopback',
  port: process.env.PORT || 3000,
  oauth: oauth,
  allowedRedirectHostname: allowedRedirectHostname
};
